import { gql } from '@apollo/client';

export const VEHICLE_BY_CARLINE = gql`
  query Carline(
    $carlineInput: ConfiguredCarByCarlineInput!
    $filterInput: RenderedCarImagesFilterInput
  ) {
    configuredCarByCarline(carlineInput: $carlineInput) {
      carline {
        id
        name
      }
      media {
        images(filterInput: $filterInput) {
          url
          category
          mimeType
          profileId
        }
      }
      model {
        id {
          code
          extensions
          version
          year
        }
        name
      }
    }
  }
`;
